<template>
    <!-- <div class="loading">
        <div class="content" :style="'width:' + width + '%'"></div>
    </div> -->
    <div style="position:relative">
        <div class="bigBody">
            <div class="smallBody" :style="'width:' + (15 + width*5.85) + 'rem'">
                <div class="smallHead"></div>
            </div>
        </div>
        <div class="bigHead"></div>
    </div>
</template>

<script>
    export default {
        name: "Loading",
        props: ["width"],
        data() {
            return {
                url: '',
                loadEnd: false
            }
        },
        mounted() {},
        beforeDestroy() {},
        methods: {}
    }
</script>

<style lang='less' scoped>
    .bigBody {
        width: 598rem;
        height: 40rem;
        background: url(../../assets/img/大电池身子.png);
        background-size: 100% 100%;
        display: flex;
        flex-direction: row;
        padding-left: 3rem;
        padding-top: 3rem;

        .smallBody {
            width: 15rem;
            height: 34rem;
            background: linear-gradient(90deg, #0070d9, #0d94ff, #87d5ff);
            border-top-left-radius: 7rem 17rem;
            border-top-right-radius: 7rem 17rem;
            border-bottom-right-radius: 7rem 17rem;
            border-bottom-left-radius: 7rem 17rem;
            // background: url(../../assets/img/小电池身子.png);
            // background-size: 100% 100%;
            position: relative;
        }

        .smallHead {
            width: 14rem;
            height: 32rem;
            background: url(../../assets/img/小电池盖子.png);
            background-size: 100% 100%;
            position: absolute;
            right: 0;
            top: 1rem;
        }
    }

    .bigHead {
        width: 22rem;
        height: 40rem;
        background: url(../../assets/img/大电池盖子.png);
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        top: 0;
    }
</style>